module.exports = __webpack_public_path__ + "static/media/sidebar-2.310509c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-2.jpg
// module id = 543
// module chunks = 0